import React from 'react';
import theme from '../../theme/theme';

const Button = ({
  children,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onClick,
  className = '',
  ...props
}) => {
  const baseClasses = `
    inline-flex items-center justify-center font-semibold rounded-2xl
    focus:outline-none focus:ring-4 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
    transition-all duration-300 ease-out
    transform hover:scale-105 active:scale-95
    shadow-lg hover:shadow-xl
    relative overflow-hidden
  `;

  const sizeClasses = {
    small: 'px-4 py-2.5 text-sm',
    medium: 'px-6 py-3.5 text-sm',
    large: 'px-8 py-4 text-base',
  };

  const classes = `
    ${baseClasses}
    ${sizeClasses[size]}
    ${className}
  `;

  const buttonStyle = variant === 'secondary' ? {
    backgroundColor: 'transparent',
    color: theme.Colors.primary,
    border: `2px solid ${theme.Colors.primary}`,
  } : {
    background: `linear-gradient(135deg, ${theme.Colors.primary} 0%, #b91c1c 100%)`,
    color: theme.Colors.textSecondary,
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={classes}
      style={buttonStyle}
      {...props}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
      
      {loading && (
        <div className="mr-3 animate-spin">
          <svg
            className="h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      )}
      <span className="relative z-10 transition-all duration-200">
        {children}
      </span>
    </button>
  );
};

export default Button; 